import { CanDeactivateFn } from '@angular/router';
import type { ContratoDetalleComponent } from './contrato-detalle.component';

export const contratoDetalleCanDeactivate: CanDeactivateFn<ContratoDetalleComponent> = (
  component,
  _currentRoute,
  _currentState,
  nextState,
) => {
  return component.confirmarSalidaSiDatosPendientes(nextState);
};
